// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"dd6f6b307302c2491799","452":"8cc22dfc5c24227fe8b3","453":"b26b7e3371d3503e06bc","522":"05d3cf74dba0f0ea97da","551":"25248c3bdc3a23fe7a4f"}[chunkId] + ".js";
};